const BaseService = require('@/services/BaseService')

const namespace = 'rooms'

const find = (id, options, cb) => {
  BaseService.get(namespace + '/' + id, options, cb);
}

const findAll = (options, cb) => {
  BaseService.get(namespace, options, cb);
}

const update = (id, options, cb) => {
  BaseService.put(namespace + '/' + id, options, cb);
}

export {
  find,
  findAll,
  update
}


// WEBPACK FOOTER //
// ./src/services/rooms/RoomService.js